import {CityProps, translatedCityProps} from 'modules/cities/types';
import {OrderProps} from 'modules/orders/types';
import {translatedUserProps, UserProps} from 'modules/users/types';
import {TranslatedKeys} from 'shared/types/translated-keys';

export interface DeliveryManBillingProps {
  id: string;
  cityId: string;
  city: CityProps;
  paid: boolean;
  isClosed: boolean;
  total: number;
  deliveries: number;
  deliveryManFee: number;
  occurrences: number;
  deliveryManAmount: number;
  startDate: Date;
  endDate: Date;
  orders: OrderProps[];
  numberOfOrders: number;
  deliveryManId: string;
  deliveryMan: UserProps;
}

export const translatedDeliveryManBillingProps: TranslatedKeys<DeliveryManBillingProps> =
  {
    cityId: 'Cidade',
    city: {...translatedCityProps, name: 'Cidade'},
    paid: 'Pago?',
    isClosed: 'Fechada?',
    total: 'Total considerado',
    deliveryManFee: 'Taxa do entregador',
    deliveries: 'Taxa de entrega',
    deliveryManAmount: 'Total a receber',
    occurrences: 'Ocorrências',
    startDate: 'Data de ínicio',
    endDate: 'Data de fim',
    orders: 'Pedidos',
    numberOfOrders: 'Quantidade de pedidos',
    deliveryManId: 'Entregador',
    deliveryMan: {...translatedUserProps, name: 'Entregador'},
  };
